function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Divider } from '@homeaway/react-collapse';
import { ARROW_RIGHT__24 } from '@homeaway/svg-defs';
import { ButtonIcon } from '@homeaway/react-buttons';
import "./SideNavigation.css";

function SideNavigation(_ref) {
  var categories = _ref.categories,
      category = _ref.category,
      family = _ref.family,
      familyDisplayName = _ref.familyDisplayName,
      localSearchComponent = _ref.localSearchComponent,
      name = _ref.name,
      onClick = _ref.onClick,
      renderOrder = _ref.renderOrder,
      subCategory = _ref.subCategory;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      expanded = _useState2[0],
      setExpanded = _useState2[1];
  /* istanbul ignore next */


  function toggleExpand() {
    setExpanded(!expanded);
  }
  /* istanbul ignore next */


  function toggleLabel() {
    return expanded ? 'Hide Navigation' : 'Expand Navigation';
  }
  /* istanbul ignore next */


  var handleNavClick = function handleNavClick(evt) {
    if (evt && evt.target && evt.target.dataset) {
      /* eslint-disable no-shadow */
      var _evt$target$dataset = evt.target.dataset,
          _evt$target$dataset$c = _evt$target$dataset.category,
          _category = _evt$target$dataset$c === void 0 ? '' : _evt$target$dataset$c,
          _evt$target$dataset$c2 = _evt$target$dataset.componentName,
          componentName = _evt$target$dataset$c2 === void 0 ? '' : _evt$target$dataset$c2,
          _evt$target$dataset$f = _evt$target$dataset.family,
          _family = _evt$target$dataset$f === void 0 ? '' : _evt$target$dataset$f,
          _evt$target$dataset$n = _evt$target$dataset.name,
          _name = _evt$target$dataset$n === void 0 ? '' : _evt$target$dataset$n,
          _evt$target$dataset$s = _evt$target$dataset.subCategory,
          _subCategory = _evt$target$dataset$s === void 0 ? '' : _evt$target$dataset$s;

      onClick(evt, {
        category: _category,
        componentName: componentName,
        family: _family,
        name: _name,
        subCategory: _subCategory
      });
    }
  };

  var sideNavClassNames = classnames('SideNavigation', {
    'SideNavigation--expanded': expanded
  });
  return /*#__PURE__*/React.createElement("div", {
    className: sideNavClassNames
  }, /*#__PURE__*/React.createElement("div", {
    className: "SideNavigation__search-container"
  }, localSearchComponent && localSearchComponent), /*#__PURE__*/React.createElement("div", {
    className: "SideNavigation__family-container"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "SideNavigation__family text-capitalize"
  }, familyDisplayName), categories.reduce(function (finalCategories, currentCategory) {
    var currentCategoryId = currentCategory.id;
    var currentCategoryDisplayName = currentCategory.displayName;
    var subCategories = currentCategory.subCategories;
    finalCategories.push( /*#__PURE__*/React.createElement("div", {
      className: "SideNavigation__category",
      key: "navtype_" + currentCategoryId
    }, /*#__PURE__*/React.createElement(Divider, {
      className: "Divider--navigation",
      expanded: currentCategoryId === category,
      heading: currentCategoryDisplayName,
      id: "divider-" + currentCategoryId
    }, /*#__PURE__*/React.createElement("ul", {
      className: "list-unstyled"
    }, renderOrder({
      currentCategory: currentCategory,
      currentCategoryId: currentCategoryId,
      family: family,
      handleNavClick: handleNavClick,
      name: name,
      subCategory: subCategory,
      subCategories: subCategories
    })))));
    return finalCategories;
  }, [])), /*#__PURE__*/React.createElement(ButtonIcon, {
    label: toggleLabel(),
    onClick: toggleExpand,
    className: "SideNavigation__toggle",
    svgMarkup: ARROW_RIGHT__24
  }));
}

SideNavigation.propTypes = {
  /** Category of the currently viewed component. */
  category: PropTypes.string.isRequired,

  /** Category name formatted for display purposes. */
  categoryDisplayName: PropTypes.string,

  /** Array of categories and subCategories with metadata. */
  categories: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    displayName: PropTypes.string.isRequired,
    subCategories: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      displayName: PropTypes.string.isRequired
    }).isRequired).isRequired
  }).isRequired).isRequired,

  /** Family of the currently viewed component. */
  family: PropTypes.string.isRequired,

  /** Family name formatted for display purposes. */
  familyDisplayName: PropTypes.string.isRequired,

  /** React component for rendering local search. */
  localSearchComponent: PropTypes.element,

  /** Repo name of the currently viewed component. */
  name: PropTypes.string,

  /** Function that outputs the render order of components by family/category/subcategory.  */
  renderOrder: PropTypes.func.isRequired,
  onClick: PropTypes.func,

  /** Currently selected sub category. */
  subCategory: PropTypes.string
};
SideNavigation.defaultProps = {
  onClick:
  /* istanbul ignore next */
  function onClick() {},
  expanded: false
};
export default SideNavigation;
//# sourceMappingURL=SideNavigation.js.map